import {
  AppBar,
  Button,
  Container,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getData } from "../../../../services/library";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import HabilitarChofer from "./habilitarChofer/HabilitarChofer";
import HabilitarDeshabilitarChofer from "./habilitarChofer/HabilitarDeshabilitarChofer";

function VerChoferes({ sucursal, onBack }) {
  const [choferesHabilitados, setchoferesHabilitados] = useState([]);
  const [alta, setAlta] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedChofer, setSelectedChofer] = useState(null);
  const [accion, setAccion] = useState(""); // "habilitar" o "deshabilitar"

  const obtenerChoferesHabilitados = () => {
    getData(
      "/envasado_rendiciones_extendidas/xsucursal/" + sucursal.id,
      (data) => {
        setchoferesHabilitados(data || []);
      }
    );
  };

  useEffect(() => {
    obtenerChoferesHabilitados();
  }, [sucursal.id]);

  const handleAddCliente = () => setAlta(true);
  const handleCloseAdd = () => {
    setAlta(false);
    obtenerChoferesHabilitados();
  };

  const handleOpenDialog = (chofer, tipoAccion) => {
    setSelectedChofer(chofer);
    setAccion(tipoAccion);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedChofer(null);
    setAccion("");
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "nombre_apellido",
        header: "Chofer",
      },
      {
        accessorKey: "estado",
        header: "Estado",
        // Cell: ({ cell }) => {
        //   const activo = cell.getValue();
        //   return (
        //     <Typography
        //       sx={{
        //         color: activo === 1 ? "green" : "red",
        //         // fontWeight: "bold",
        //       }}
        //     >
        //       {activo === 1 ? "HABILITADO" : "DESHABILITADO"}
        //     </Typography>
        //   );
        // },
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

  return (
    <div>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onBack}>
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Choferes de {sucursal.nombre}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={choferesHabilitados ?? []}
          layoutMode={"grid"}
          initialState={initialState}
          enableColumnActions={false}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableRowActions={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn={"last"}
          enableExpandAll={false}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={tableHeadCellProps}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          enableDensityToggle={false}
          displayColumnDefOptions={displayColumnDefOptions}
          enableColumnResizing={true}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
            sx: {
              backgroundColor: row.original.activo === 1 ? "#e8f5e9" : "#ffebee",
              color: "black",
            },
          })}
          renderTopToolbarCustomActions={() => (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddBoxTwoToneIcon />}
              onClick={handleAddCliente}
            >
              Habilitar Chofer
            </Button>
          )}
          renderRowActions={({ row }) => (
            <Box sx={{ display: "flex", gap: "8px" }}>
              {row.original.activo === 0 ? (
                <Tooltip arrow placement="right" title="Habilitar Rendiciones Extendidas">
                  <IconButton
                    onClick={() => handleOpenDialog(row.original, "habilitar")}
                    color="success"
                  >
                    <AlarmOnIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip arrow placement="right" title="Deshabilitar Rendiciones Extendidas">
                  <IconButton
                    onClick={() => handleOpenDialog(row.original, "deshabilitar")}
                    color="error"
                  >
                    <AlarmOffIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )}
        />
      </Container>
      {alta && (
        <HabilitarChofer
          alta={alta}
          onClose={handleCloseAdd}
          sucursal={sucursal}
          choferesHabilitados={choferesHabilitados}
        />
      )}
      
      {/* Dialog para habilitar/deshabilitar */}
      <HabilitarDeshabilitarChofer
        open={openDialog}
        setOpen={setOpenDialog}
        chofer={selectedChofer}
        accion={accion}
        actualizar={obtenerChoferesHabilitados}
      />
    </div>
  );
}

export default VerChoferes;